
import React, { useState,useEffect,useCallback } from "react";
//import { AgGridColumn, AgGridReact } from 'ag-grid-community';
import Axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../Assets/fontawesome';
import BtnCellRenderer from "./BtnCellRenderer";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import ScaleLoader from "react-spinners/ScaleLoader";

const GroupList=(props)=>{

    const [groupList,setGroupList]=useState([]);
const[pageSize,setPageSize]=useState(10);
const [isLoading,setLoading]=useState(false);
    
    ///----ag grid----//
    const [gridApi,setGridApi]=useState()
    const columnDefs = [
      { headerName: "Name", field: "name",},
      { headerName: "Sub Group", field: "subgroup",},
      { headerName: "Category", field: "categoryName", },
      { headerName: "Action", cellRenderer: "BtnCellRenderer"},
    ]  

    const defaultColDef = {
      sortable: true,
      editable: true,
      flex: 1, filter: true,
      floatingFilter: true, 
    }
  
    const onGridReady = (params) => {
        setGridApi(params.api);
    
        loadGroupList();
        params.api.paginationGoToPage(10);
       
      };
    
      const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
      };
    //a g grid end----//
     
    // useEffect(() => {
    //     loadGroupList();
    // },[]);
    
    const loadGroupList=async()=>{
        setLoading(true);
       await Axios.post(props.apiUrlPrefix + "/getGroupsAdmin",null,props.apiHeaderRequest)
        .then((res) => {
            if(res!=null && res.data!=null && res.data.statusCode===200 && res.data.body.length>0 ){
                var lst = res.data.body;

                lst.map(data=>{
                    data.categoryName=data.grpcat.name
                })
                setGroupList(lst);
            }
            setLoading(false);
        })
        .catch(err => {  
            console.log(err) ;
            setLoading(false);
        });
    }

    const btnDeleteGroup=(id)=>{
        setLoading(true);
        const params ={
            groupId:id
        }
        Axios.post(props.apiUrlPrefix + "/archiveGroup",params,props.apiHeaderRequest)
        .then((res) => {
            if(res!=null && res.data!=null && res.data.statusCode===200 && res.data.body.id>0 ){
                alert('Group has been archived successfully.');
                loadGroupList();
            }
            setLoading(false);
        })
        .catch(err => {  
            console.log(err) ;
            setLoading(false);
        });
    }

    return (
        <React.Fragment>
            <div className={isLoading?'loader-style':''} >
        <ScaleLoader
          size={150}
          color={"white"}
          loading={isLoading}
        />
      </div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 ">
                            <h2>Group List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="content-fluid">

<div className="card">
<div className="card-body">
<div className="row">
    <div className="col-md-12">
    <span className="pull-left">Page size: <select onChange={(e)=>onPageSizeChanged(e.target.value)}>
        <option value='10'>10</option>
        <option value='25'>25</option>
        <option value='50'>50</option>
        <option value='100'>100</option>
      </select>
    </span>
    <a href="/group"><span className="btn btn-sm btn-info float-right "    >+ Create Group</span></a>
    </div>
    <div className="col-md-12 ag-theme-alpine "  >
        <AgGridReact
       columnDefs={columnDefs}
       defaultColDef={defaultColDef}
      pagination={true}
      paginationPageSize={10}
      onGridReady={onGridReady}
      rowData={groupList}
      domLayout={'autoHeight'}
      frameworkComponents={{BtnCellRenderer}}
      context={{ btnDeleteGroup }}
      overlayLoadingTemplate={
        '<span className="ag-overlay-loading-center">Please wait while your rows are loading</span>'
      }
          >
        </AgGridReact>
    </div>
</div>

     
</div>
</div>
                </div>
            </div>
        </React.Fragment>
        
    )
}

export default GroupList